import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import '@/assets/css/main.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { globalConfig } from '@/assets/js/const';

const app = createApp(App);

// 动态设置 rem 基准
const setRem = () => {
    const width = window.innerWidth;
    let baseSize;

    // 根据屏幕宽度设置 rem 基准
    if (width < 400) {
        baseSize = 12; // 超小屏幕（如小型手机）
    } else if (width < 600) {
        baseSize = 14; // 小屏幕（如手机）
    } else if (width < 1024) {
        baseSize = 15; // 中等屏幕（如平板）
    } else if (width < 1920) {
        baseSize = 16; // 桌面标准屏幕
    } else {
        baseSize = 18; // 大屏幕（如高分辨率桌面）
    }

    document.documentElement.style.fontSize = `${baseSize}px`;
};

setRem();

window.addEventListener('resize', setRem);

app.use(store).use(router).use(ElementPlus);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

app.mount('#app');

// 动态设置页面标题 - 在路由变化时更新
router.afterEach(() => {
    const lang = localStorage.getItem('lang') || globalConfig.currentLang;
    document.title = lang === 'cn' ? '大海怪支付中心' : '7 Pirates Store';
});